import gsap from "gsap";
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".scroll").forEach((item, index) => {
    item.addEventListener("click", (event) => {
        // Prevent the default action
        event.preventDefault();
        let target = event.target;
        let hash = target.hash;

        gsap.to(window, {
            duration: 1,
            scrollTo: {y: hash, offsetY: 50},
            ease: "Power1.easeInOut"
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {
    const tl1 = gsap.timeline({ repeat: -1 })
    const mtl1 = gsap.timeline({ repeat: -1 })
    const tl2 = gsap.timeline();
    const tl3 = gsap.timeline();
    const tl4 = gsap.timeline();
    const tl5 = gsap.timeline();
    const mtl2 = gsap.timeline();
    const mtl3 = gsap.timeline();
    const mtl4 = gsap.timeline();
    const mtl5 = gsap.timeline();
    const mtl6 = gsap.timeline();
    const mtl7 = gsap.timeline();

    tl1.to("#eQaEhqIprRL29", { x: 1920 ,y:265,duration: 2 ,ease:'power1.inOut'})
    tl2.to("#eQaEhqIprRL29", { opacity:0,duration: 1 ,ease:'power1.inOut'})
    tl1.to("#eQaEhqIprRL5", { opacity:1,duration: 1 ,ease:'power1.inOut'})
    tl1.to("#eQaEhqIprRL5", { opacity:0,duration: 1 ,ease:'power1.inOut'})

    tl3.to("#eQaEhqIprRL11", { opacity:1,duration: 1 ,ease:'power1.inOut'})
    tl3.to("#eQaEhqIprRL11", { opacity:1,duration: 5.5 ,ease:'power1.inOut'})
    tl3.to("#eQaEhqIprRL11", { opacity:0,duration: 0.5 ,ease:'power1.inOut'})

    tl4.to("#eQaEhqIprRL18", { opacity:1,duration: 0.5 ,ease:'power1.inOut'})
    tl4.to("#eQaEhqIprRL18", { opacity:1,duration: 5 ,ease:'power1.inOut'})
    tl4.to("#eQaEhqIprRL18", { opacity:0,duration: 0.5 ,ease:'power1.inOut'})

    tl5.to("#eQaEhqIprRL23", { opacity:1,duration: 1 ,ease:'power1.inOut'})
    tl5.to("#eQaEhqIprRL23", { opacity:0,duration: 0.9 ,ease:'power1.inOut'})
    tl5.to("#eQaEhqIprRL23", { opacity:1,duration: 0.9 ,ease:'power1.inOut'})
    tl5.to("#eQaEhqIprRL23", { opacity:1,duration: 0.7 ,ease:'power1.inOut'})
    tl5.to("#eQaEhqIprRL23", { opacity:0,duration: 0.5 ,ease:'power1.inOut'})
    tl5.to("#eQaEhqIprRL23", { opacity:1,duration: 0.5 ,ease:'power1.inOut'})
    tl5.to("#eQaEhqIprRL23", { opacity:1,duration: 0.9 ,ease:'power1.inOut'})
    tl5.to("#eQaEhqIprRL23", { opacity:0,duration: 0.5 ,ease:'power1.inOut'})


    tl1.add(tl2, 1);
    tl1.add(tl3, 3);
    tl1.add(tl4,4);
    tl1.add(tl5,3.5);
    tl1.play()

    mtl1.to("#evgUD46Ay3730", { x: 750 ,y:309,duration: 1 ,ease:'power1.inOut'})
    mtl2.to("#evgUD46Ay3730", { opacity:1,duration: 0.7 ,ease:'power1.inOut'})
    mtl2.to("#evgUD46Ay3730", { opacity:0,duration: 0.3 ,ease:'power1.inOut'})


    mtl3.to("#evgUD46Ay375", { opacity:1,duration: 1 ,ease:'power1.inOut'})
    mtl3.to("#evgUD46Ay375", { opacity:0,duration: 1 ,ease:'power1.inOut'})

    mtl4.to("#evgUD46Ay3724", { opacity:0,duration: 0.5 ,ease:'power1.inOut'})

    mtl5.to("#evgUD46Ay3711", { opacity:1,duration: 1 ,ease:'power1.inOut'})
    mtl5.to("#evgUD46Ay3711", { opacity:1,duration: 6.6 ,ease:'power1.inOut'})
    mtl5.to("#evgUD46Ay3711", { opacity:0,duration: 0.7 ,ease:'power1.inOut'})

    mtl6.to("#evgUD46Ay3732", { opacity:1,duration: 0.8 ,ease:'power1.inOut'})
    mtl6.to("#evgUD46Ay3732", { opacity:0,duration: 0.8 ,ease:'power1.inOut'})
    mtl6.to("#evgUD46Ay3732", { opacity:1,duration: 1 ,ease:'power1.inOut'})
    mtl6.to("#evgUD46Ay3732", { opacity:1,duration: 0.8 ,ease:'power1.inOut'})
    mtl6.to("#evgUD46Ay3732", { opacity:0,duration: 0.8 ,ease:'power1.inOut'})
    mtl6.to("#evgUD46Ay3732", { opacity:1,duration: 0.8 ,ease:'power1.inOut'})
    mtl6.to("#evgUD46Ay3732", { opacity:1,duration: 0.9 ,ease:'power1.inOut'})
    mtl6.to("#evgUD46Ay3732", { opacity:0,duration: 0.8 ,ease:'power1.inOut'})
    mtl6.to("#evgUD46Ay3732", { opacity:1,duration: 0.7 ,ease:'power1.inOut'})

    mtl7.to("#evgUD46Ay3739", { opacity:1,duration: 1 ,ease:'power1.inOut'})
    mtl7.to("#evgUD46Ay3739", { opacity:1,duration: 4.8 ,ease:'power1.inOut'})
    mtl7.to("#evgUD46Ay3739", { opacity:0,duration: 0.7 ,ease:'power1.inOut'})

    mtl1.add(mtl2, 0);
    mtl1.add(mtl3, 1);
    mtl1.add(mtl4, 1);
    mtl1.add(mtl5, 1.7);
    mtl1.add(mtl6, 1.9);
    mtl1.add(mtl7, 3.5);
    mtl1.play()

    const scale=document.body.clientWidth/375;

    const prev = document.getElementsByClassName('prev')[0];
    const next = document.getElementsByClassName('next')[0];
    const milestone=document.getElementsByClassName('milestone')[0];
    const mContainer=document.getElementsByClassName('m-container')[0];

    const prevTip = document.getElementsByClassName('prev-tip')[0];
    const nextTip = document.getElementsByClassName('next-tip')[0];
    const sContainer=document.getElementsByClassName('s-container')[0];

    mContainer.style.width=`${scale*220}px`;
    mContainer.querySelector(".milestone").setAttribute('width', `${parseInt(scale*1230)}px`);

    let index=0,sindex=0;

    prevTip.addEventListener('click', () => {
        if(0===index)return
        index+=1
        toTip(index)
    })
    nextTip.addEventListener('click', () => {
        if(-4===index)return
        index-=1
        toTip(index)
    })
    prev.addEventListener('click', () => {
        if(0===index)return
        index+=1
        toMileStone(index)
    })
    next.addEventListener('click', () => {
        if(-4===index)return
        index-=1
        toMileStone(index)
    })
    const fadeElements = document.querySelectorAll('.fade-in');
    fadeElements.forEach((element) => {
        gsap.set(element, { opacity: 0 });

        ScrollTrigger.create({
            trigger: element,
            start: 'top 80%', // Adjust the start position as needed
            onEnter: () => {
                gsap.to(element, {
                    opacity: 1,
                    duration: 2, // Animation duration
                });
            },
        });
    });



    function toTip (i){
        gsap.to(sContainer, 1, { x: scale*i*375 });
    }
    function toMileStone (i){
        gsap.to(milestone, 1, { x: scale*252*i });

    }

    const dialog = document.querySelector("dialog")
    const openBtn=document.querySelectorAll("[data-open-modal]")
    const closeBtn=document.querySelector("[data-close-modal]")
    const pageContainers=document.querySelectorAll("[data-content]")
    openBtn.forEach(item => {
        item.addEventListener("click", function(e) {
            pageContainers.forEach((c)=>{
                if(c.getAttribute('data-content')!==this.getAttribute('data-page')){
                    c.classList.add('hidden')
                }else{
                    c.classList.remove('hidden')
                    const fadeElements = c.querySelectorAll(".fade-in-el");
                    const timeline = gsap.timeline();
                    fadeElements.forEach((element, index) => {
                        timeline.from(element, {
                            opacity: 0,
                            duration:.6, // Adjust the duration as needed
                            ease: "power2.out", // Use a desired easing function
                        });
                    });
                }
            })

            dialog.showModal();
            gsap.from(dialog,{opacity: 0,
                duration:.6, // Adjust the duration as needed
                ease: "power2.out",})
        });
    } )
    closeBtn.addEventListener('click', (e) => {
            dialog.close()
    })
})

